<div class="container">

    <app-header-dialog [iconName]="'school'">
     Formação
  </app-header-dialog>


  <div class='content'>

    <form name="form" [formGroup]='form' autocomplete="off">

      <div style="display: flex; flex-direction: row; justify-content: space-between;">

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Data Início</mat-label>
          <input matInput [matDatepicker]="pickerDateStart" [errorStateMatcher]="matcher"
            [formControl]="form.controls.dateStart">
          <mat-datepicker-toggle matSuffix [for]="pickerDateStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerDateStart></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Data Término</mat-label>
          <input matInput [matDatepicker]="pickerDateEnd" [errorStateMatcher]="matcher"
            [formControl]="form.controls.dateEnd">
          <mat-datepicker-toggle matSuffix [for]="pickerDateEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerDateEnd></mat-datepicker>
        </mat-form-field>

      </div>


      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="form.controls.text"
          autocomplete="off">
        <mat-error *ngIf="form.controls.text.hasError('required')">
          A descrição é obrigatória
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Local da Formação</mat-label>
        <mat-select [errorStateMatcher]="matcher" [formControl]="form.controls.location">
          <mat-option *ngFor="let location of backgroundLocations" [value]="location.value">
            {{ location.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.location.hasError('required')">
          O Local é obrigatório
        </mat-error>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button [disabled]='form.invalid' mat-raised-button
      (click)="matDialogRef.close([ 'add', form ])" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

    <button [disabled]='form.invalid' mat-raised-button
    (click)="matDialogRef.close([ 'edit', form ])" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
  </button>

  </div>

</div>